import React, { useState, useEffect } from "react";
import styled from '@emotion/styled';
import ImgStudents from "../assets/images/CNC-Students.jpg";
import ImageTitle from "../components/ImageTitle";

// ── Catálogo 1 (el que ya tienes) ─────────────────────────────────
import Cat1 from "../assets/images/Catalogo/1.png";
import Cat2 from "../assets/images/Catalogo/2.png";
import Cat4 from "../assets/images/Catalogo/4.png";
import Cat5 from "../assets/images/Catalogo/5.png";
import Cat6 from "../assets/images/Catalogo/6.png";
import Cat7 from "../assets/images/Catalogo/7.png";
import Cat8 from "../assets/images/Catalogo/8.png";
import Cat9 from "../assets/images/Catalogo/9.png";
import Cat10 from "../assets/images/Catalogo/10.png";
import Cat11 from "../assets/images/Catalogo/11.png";
import Cat12 from "../assets/images/Catalogo/12.png";
import Cat13 from "../assets/images/Catalogo/13.png";
import Cat15 from "../assets/images/Catalogo/15.png";
import Cat16 from "../assets/images/Catalogo/16.png";
import Cat17 from "../assets/images/Catalogo/17.png";
import Cat18 from "../assets/images/Catalogo/18.png";
import Cat19 from "../assets/images/Catalogo/19.png";
import Cat20 from "../assets/images/Catalogo/20.png";
import Cat21 from "../assets/images/Catalogo/21.png";
import Cat22 from "../assets/images/Catalogo/22.png";
import Cat23 from "../assets/images/Catalogo/23.png";
import Cat24 from "../assets/images/Catalogo/24.png";
import Cat25 from "../assets/images/Catalogo/25.png";
import Cat26 from "../assets/images/Catalogo/26.png";
import Cat27 from "../assets/images/Catalogo/27.png";
import Cat28 from "../assets/images/Catalogo/28.png";
import Cat29 from "../assets/images/Catalogo/29.png";
import Cat30 from "../assets/images/Catalogo/30.png";
import Cat31 from "../assets/images/Catalogo/31.png";
import Cat32 from "../assets/images/Catalogo/32.png";
import Cat33 from "../assets/images/Catalogo/33.png";
import Cat34 from "../assets/images/Catalogo/34.png";
import Cat35 from "../assets/images/Catalogo/35.png";
import Cat36 from "../assets/images/Catalogo/36.png";
import Cat50 from "../assets/images/Catalogo/50.png";

// ── Catálogo 2 (nuevo) ────────────────────────────────────────────
import Cat2_1 from "../assets/images/Catalogo2/1.png";
import Cat2_2 from "../assets/images/Catalogo2/2.png";
import Cat2_3 from "../assets/images/Catalogo2/3.png";
import Cat2_4 from "../assets/images/Catalogo2/4.png";
import Cat2_5 from "../assets/images/Catalogo2/5.png";
import Cat2_6 from "../assets/images/Catalogo2/6.png";
import Cat2_7 from "../assets/images/Catalogo2/7.png";
import Cat2_8 from "../assets/images/Catalogo2/8.png";
import Cat2_9 from "../assets/images/Catalogo2/9.png";
import Cat2_10 from "../assets/images/Catalogo2/10.png";
import Cat2_11 from "../assets/images/Catalogo2/11.png";
import Cat2_12 from "../assets/images/Catalogo2/12.png";
import Cat2_13 from "../assets/images/Catalogo2/13.png";
import Cat2_14 from "../assets/images/Catalogo2/14.png";
import Cat2_15 from "../assets/images/Catalogo2/15.png";
import Cat2_16 from "../assets/images/Catalogo2/16.png";
import Cat2_17 from "../assets/images/Catalogo2/17.png";
import Cat2_18 from "../assets/images/Catalogo2/18.png";
import Cat2_19 from "../assets/images/Catalogo2/19.png";
import Cat2_20 from "../assets/images/Catalogo2/20.png";
import Cat2_21 from "../assets/images/Catalogo2/21.png";
import Cat2_22 from "../assets/images/Catalogo2/22.png";
import Cat2_23 from "../assets/images/Catalogo2/23.png";
import Cat2_24 from "../assets/images/Catalogo2/24.png";
import Cat2_25 from "../assets/images/Catalogo2/25.png";
import Cat2_26 from "../assets/images/Catalogo2/26.png";
import Cat2_27 from "../assets/images/Catalogo2/27.png";
import Cat2_28 from "../assets/images/Catalogo2/28.png";
import Cat2_29 from "../assets/images/Catalogo2/29.png";
import Cat2_30 from "../assets/images/Catalogo2/30.png";
import Cat2_31 from "../assets/images/Catalogo2/31.png";
import Cat2_32 from "../assets/images/Catalogo2/32.png";
import Cat2_33 from "../assets/images/Catalogo2/33.png";
import Cat2_34 from "../assets/images/Catalogo2/34.png";
import Cat2_35 from "../assets/images/Catalogo2/35.png";
import Cat2_36 from "../assets/images/Catalogo2/36.png";
import Cat2_37 from "../assets/images/Catalogo2/37.png";
import Cat2_38 from "../assets/images/Catalogo2/38.png";
import Cat2_39 from "../assets/images/Catalogo2/39.png";
import Cat2_40 from "../assets/images/Catalogo2/40.png";
import Cat2_41 from "../assets/images/Catalogo2/41.png";
import Cat2_42 from "../assets/images/Catalogo2/42.png";
import Cat2_43 from "../assets/images/Catalogo2/43.png";
import Cat2_44 from "../assets/images/Catalogo2/44.png";
import Cat2_45 from "../assets/images/Catalogo2/45.png";
import Cat2_46 from "../assets/images/Catalogo2/46.png";
import Cat2_47 from "../assets/images/Catalogo2/47.png";
import Cat2_48 from "../assets/images/Catalogo2/48.png";
import Cat2_49 from "../assets/images/Catalogo2/49.png";
import Cat2_50 from "../assets/images/Catalogo2/50.png";
import Cat2_51 from "../assets/images/Catalogo2/51.png";
import Cat2_52 from "../assets/images/Catalogo2/52.png";
import Cat2_53 from "../assets/images/Catalogo2/53.png";

// ── Arrays de imágenes ────────────────────────────────────────────
const catalogImages1 = [
  Cat1, Cat2, Cat4, Cat5, Cat6, Cat7, Cat8, Cat9, Cat10,
  Cat11, Cat12, Cat13, Cat15, Cat16, Cat17, Cat18, Cat19,
  Cat20, Cat21, Cat22, Cat23, Cat24, Cat25, Cat26, Cat27,
  Cat28, Cat29, Cat30, Cat31, Cat32, Cat33, Cat34, Cat35,
  Cat36, Cat50
];

const catalogImages2 = [
  Cat2_1, Cat2_2, Cat2_3, Cat2_4, Cat2_5, Cat2_6, Cat2_7, Cat2_8, Cat2_9,
  Cat2_10, Cat2_11, Cat2_12, Cat2_13, Cat2_14, Cat2_15, Cat2_16, Cat2_17,
  Cat2_18, Cat2_19, Cat2_20, Cat2_21, Cat2_22, Cat2_23, Cat2_24, Cat2_25,
  Cat2_26, Cat2_27, Cat2_28, Cat2_29, Cat2_30, Cat2_31, Cat2_32, Cat2_33,
  Cat2_34, Cat2_35, Cat2_36, Cat2_37, Cat2_38, Cat2_39, Cat2_40, Cat2_41,
  Cat2_42, Cat2_43, Cat2_44, Cat2_45, Cat2_46, Cat2_47, Cat2_48, Cat2_49,
  Cat2_50, Cat2_51, Cat2_52, Cat2_53
];

// ── Configuración de los catálogos (solo edita aquí) ──────────────
const CATALOGS = [
  {
    id: 1,
    label: "Catálogo 2026",
    images: catalogImages1,
  },
  {
    id: 2,
    label: "Catálogo 2026 2",
    images: catalogImages2,
    comingSoon: false,
  },
];

// ── Styled components ─────────────────────────────────────────────
const CatalogDiv = styled.div`
  background: #f2f2f2;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TabRow = styled.div`
  display: flex;
  gap: 0;
  margin-top: 30px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
`;

const TabBtn = styled.button`
  background: ${({ active }) => (active ? '#cc0000' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#cc0000')};
  border: 2px solid #cc0000;
  padding: 10px 28px;
  font-family: "Oswald", sans-serif;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;

  &:first-of-type { border-right: none; }
  &:last-of-type  { border-left: none; }
  &:hover { background: ${({ active }) => (active ? '#aa0000' : '#fff5f5')}; }
`;

const ViewerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

const ViewerCard = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  width: 90%;
  max-width: 680px;
  display: flex;
  flex-direction: column;
`;

const ViewerHeader = styled.div`
  background: #cc0000;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ViewerTitle = styled.p`
  font-family: "Oswald", sans-serif;
  color: white;
  font-size: 15px;
  letter-spacing: 1px;
  margin: 0;
`;

const Counter = styled.span`
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  padding: 4px 12px;
`;

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #111;
  aspect-ratio: 3 / 4;

  @media (max-width: 480px) {
    aspect-ratio: 3 / 5;
  }
`;

const ImageSlide = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  opacity: ${({ animating }) => (animating ? 0 : 1)};
  transition: opacity 0.3s ease;
  user-select: none;
  -webkit-user-drag: none;
`;

const ComingSoonBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 3 / 4;
  background: #1a1a1a;
  color: #fff;
  gap: 12px;

  span:first-of-type { font-size: 48px; }

  p {
    font-family: "Oswald", sans-serif;
    font-size: 16px;
    letter-spacing: 2px;
    color: #aaa;
    margin: 0;
  }
`;

const ArrowBtn = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => direction === 'left' ? 'left: 12px;' : 'right: 12px;'}
  background: rgba(0, 0, 0, 0.45);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  z-index: 10;

  &:hover { background: rgba(204, 0, 0, 0.75); }

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
`;

const ViewerFooter = styled.div`
  background: #f9f9f9;
  border-top: 1px solid #e0e0e0;
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const DotsRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
`;

const Dot = styled.button`
  width: ${({ active }) => (active ? '20px' : '8px')};
  height: 8px;
  border-radius: 4px;
  border: none;
  background: ${({ active }) => (active ? '#cc0000' : '#ccc')};
  cursor: pointer;
  padding: 0;
  transition: width 0.3s ease, background 0.3s ease;
`;

const FooterText = styled.p`
  font-family: "DM Sans", sans-serif;
  font-size: 12px;
  color: #888;
  margin: 0;
  text-align: center;
`;

// ── Componente principal ──────────────────────────────────────────
const Catalog = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeCatalog, setActiveCatalog] = useState(0);
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [touchStart, setTouchStart] = useState(null);

  const catalogData = CATALOGS[activeCatalog];
  const images = catalogData.images;
  const total = images.length;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 420);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTabChange = (index) => {
    setActiveCatalog(index);
    setCurrent(0);
  };

  const goTo = (index) => {
    if (isAnimating || total === 0) return;
    setIsAnimating(true);
    setCurrent((index + total) % total);
    setTimeout(() => setIsAnimating(false), 300);
  };

  const prev = () => goTo(current - 1);
  const next = () => goTo(current + 1);

  const handleTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) diff > 0 ? next() : prev();
    setTouchStart(null);
  };

  return (
    <CatalogDiv>
      <ImageTitle
        title="CATÁLOGO DIGITAL"
        subtitle={isMobile ? null : "COORDINACIÓN NACIONAL DE CAPACITACIÓN"}
        subtitle2={isMobile ? null : "COORDINACIÓN NACIONAL DE SOCORROS"}
        image={ImgStudents}
      />

      <TabRow>
        {CATALOGS.map((cat, i) => (
          <TabBtn
            key={cat.id}
            active={activeCatalog === i}
            onClick={() => handleTabChange(i)}
          >
            {cat.label}
          </TabBtn>
        ))}
      </TabRow>

      <ViewerWrapper>
        <ViewerCard>
          <ViewerHeader>
            <ViewerTitle>📋 {catalogData.label}</ViewerTitle>
            {!catalogData.comingSoon && (
              <Counter>{current + 1} / {total}</Counter>
            )}
          </ViewerHeader>

          {catalogData.comingSoon ? (
            <ComingSoonBox>
              <span>📂</span>
              <p>PRÓXIMAMENTE</p>
            </ComingSoonBox>
          ) : (
            <CarouselContainer
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <ImageSlide
                src={images[current]}
                alt={`Página ${current + 1} del catálogo`}
                animating={isAnimating}
                draggable={false}
              />
              <ArrowBtn direction="left" onClick={prev} aria-label="Anterior">‹</ArrowBtn>
              <ArrowBtn direction="right" onClick={next} aria-label="Siguiente">›</ArrowBtn>
            </CarouselContainer>
          )}

          <ViewerFooter>
            {!catalogData.comingSoon && (
              <DotsRow>
                {images.map((_, i) => (
                  <Dot
                    key={i}
                    active={i === current}
                    onClick={() => goTo(i)}
                    aria-label={`Ir a página ${i + 1}`}
                  />
                ))}
              </DotsRow>
            )}
            <FooterText>
              Coordinación Nacional de Capacitación · Cruz Roja Mexicana
            </FooterText>
          </ViewerFooter>
        </ViewerCard>
      </ViewerWrapper>
    </CatalogDiv>
  );
};

export default Catalog;